import { z } from 'zod';
const BriefSectionSchema = z.object({
    name: z.string().describe('Section title'),
    content: z
        .record(z.string(), z.unknown())
        .nullable()
        .describe('TipTap document JSON. AI-skipped and aiAllowed=false sections receive an empty doc { type: "doc", content: [] } instead of null. Nullable retained for backwards-compatible widget consumers.'),
    position: z.number().describe('Section order position'),
    required: z.boolean().describe('Whether this section must be filled before submit'),
    aiAllowed: z.boolean().describe('Whether AI may generate content for this section'),
    audienceIds: z.array(z.string()).default([]).describe('Audience IDs relevant to this section'),
});
const BriefSourceSchema = z.object({
    sourceType: z
        .enum(['document', 'artifact', 'knowledge_base'])
        .describe('Type of source used during generation'),
    sourceId: z.string().describe('ID of the source (assetId, artifactId, or knowledgeBaseId)'),
    metadata: z
        .record(z.string(), z.unknown())
        .optional()
        .describe('Source-specific metadata (e.g. fileName, mimeType for documents)'),
});
export const BriefGenerationDataSchema = z.object({
    title: z.string().describe('Brief title'),
    summary: z.string().nullable().optional().describe('AI-generated brief summary'),
    briefType: z.string().describe('Brief type'),
    fields: z.record(z.string(), z.unknown()).nullable().describe('RJSF schema for form fields'),
    values: z.record(z.string(), z.unknown()).describe('Generated field values'),
    referenceTemplateId: z
        .string()
        .nullable()
        .describe('ID of the matched template, or null for default'),
    sections: z.array(BriefSectionSchema).describe('Brief sections with TipTap content'),
    sources: z
        .array(BriefSourceSchema)
        .optional()
        .describe('Input sources used during brief generation'),
});
export const BriefGenerationWidgetKey = 'brief-generation-widget:v1';
export const BriefGenerationWidgetKind = 'brief';
export const BriefGenerationWidgetSchema = z.object({
    brief: BriefGenerationDataSchema,
});
